// extracted by mini-css-extract-plugin
export default {"card":"CardWrapper_card__E-SpP"};